import { UserLoginTypeEnum } from 'constants-user';

export default function getAngusLogin(logins: any, userKey: any) {
  return logins.find(
    (l: any) =>
      l.key.toLowerCase() === userKey.toLowerCase() &&
      l.type === UserLoginTypeEnum.Email
  );
}
